import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ jobAspectCertificateAddFromTemplateShow: true });
  component.jobAspectCertificateAddFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.jobAspectCertificateAddFromTemplate.current?.formRef.current?.resetFields();
    component.jobAspectCertificateAddFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], aspectCertificateTemplatePresetContentList: [] });
    setTimeout(() => {
      component.jobAspectCertificateAddFromTemplate.current?.additionalFormRef.current?.child.current?.getAspectCertificateTemplateData();
      component.jobAspectCertificateAddFromTemplate.current?.getAspectCertificateTemplatePresetDataSource();
      console.log(component.jobAspectCertificateAddFromTemplate.current?.additionalFormRef.current?.child.current)
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//弹出mailmerge的div
export function docMergeJobAspectCertificate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.JobAspectCertificateId, mailMergeObj: parameter, dataModelType: 7 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(7, parameter.JobAspectCertificateId);
  }, config.setTimeoutMilliSecond);
}
